import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediationStep from './mediation-step-model'
import {
  CreateMediationStepAsync,
  DeleteMediationStepAsync,
  LoadMediationStepsAsync,
} from './mediationStep-thunk'
const initialState: mediationStepSliceState = {
  mediationStep: [],
  selected_mediationStep: '',
  is_loading_mediationStep: false,
  is_creating_mediationStep: false,
  is_deleting_mediationStep: false,
}
export interface mediationStepSliceState {
  mediationStep: MediationStep[]
  selected_mediationStep?: string
  is_loading_mediationStep: boolean
  is_creating_mediationStep: boolean
  is_deleting_mediationStep: boolean
}
export const mediationStepSlice = createSlice({
  name: 'mediationStep',
  initialState,
  reducers: {
    setSelectedmediationStep: (state, action) => {
      state.selected_mediationStep = action.payload
    },
    clearStatemediationStep: (state) => {
      state.mediationStep = []
      state.is_loading_mediationStep = false
      state.is_creating_mediationStep = false
      state.is_deleting_mediationStep = false
    },
    mergemediationStep: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediationStep = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediationStep = merge(state.mediationStep, payload) as any
        }
      }
    },

    add_mediationStep: (state, action) => {
      if (action.payload) {
        state.mediationStep = [...state.mediationStep, action.payload]
      }
    },
    set_mediationStep: (state, action) => {
      let { key, value, id } = action.payload
      state.mediationStep = state.mediationStep.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediationStepsAsync.pending, (state) => {
      state.is_loading_mediationStep = true
    })
    builder.addCase(LoadMediationStepsAsync.fulfilled, (state, action) => {
      state.is_loading_mediationStep = false
      if (action.payload) {
        state.mediationStep = action.payload
      }
    })
    builder.addCase(LoadMediationStepsAsync.rejected, (state) => {
      state.is_loading_mediationStep = false
    })
    builder.addCase(CreateMediationStepAsync.pending, (state) => {
      state.is_creating_mediationStep = true
    })
    builder.addCase(CreateMediationStepAsync.fulfilled, (state) => {
      state.is_creating_mediationStep = false
    })
    builder.addCase(CreateMediationStepAsync.rejected, (state) => {
      state.is_creating_mediationStep = false
    })
    builder.addCase(DeleteMediationStepAsync.pending, (state) => {
      state.is_deleting_mediationStep = true
    })
    builder.addCase(DeleteMediationStepAsync.fulfilled, (state, action) => {
      state.is_deleting_mediationStep = false
      if (state.mediationStep) {
        state.mediationStep = state.mediationStep.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediationStepAsync.rejected, (state) => {
      state.is_deleting_mediationStep = false
    })
  },
})

export const {
  clearStatemediationStep,
  setSelectedmediationStep,
  set_mediationStep,
  mergemediationStep,
  add_mediationStep,
} = mediationStepSlice.actions

export const get_mediationStep =
  (id?: string) =>
  (state: {
    mediationStep: {
      mediationStep: MediationStep[]
    }
  }): MediationStep | null => {
    let temp = state?.mediationStep?.mediationStep?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.mediationStep?.mediationStep[0] || null
  }
export const get_selected_mediationStep = (state: {
  mediationStep: mediationStepSliceState
}): MediationStep | null => {
  let id = state?.mediationStep?.selected_mediationStep
  let temp = state?.mediationStep?.mediationStep?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediationStep = (state: {
  mediationStep: {
    mediationStep: MediationStep[]
  }
}): MediationStep[] => {
  let temp = state?.mediationStep?.mediationStep
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediationStep_busy = (state: {
  mediationStep: mediationStepSliceState
}) => {
  return (
    state?.mediationStep.is_deleting_mediationStep ||
    state?.mediationStep.is_loading_mediationStep ||
    state?.mediationStep.is_creating_mediationStep
  )
}
export const is_deleting_mediationStep_busy = (state: {
  mediationStep: mediationStepSliceState
}) => {
  return state?.mediationStep.is_deleting_mediationStep
}
export const is_loading_mediationStep_busy = (state: {
  mediationStep: mediationStepSliceState
}) => {
  return state?.mediationStep.is_loading_mediationStep
}
export const is_creating_mediationStep_busy = (state: {
  mediationStep: mediationStepSliceState
}) => {
  return state?.mediationStep.is_creating_mediationStep
}

export default mediationStepSlice.reducer
